module.exports = __webpack_public_path__ + "img/2.ba588aa3.png";